// extracted by mini-css-extract-plugin
export default {"resendButtonContainer":"vxoA71CnuHWr357SHHWu","timer":"ntBWX5dwPGiUbOlUWxKT"};